import React from 'react';

import { Typography } from '@mui/material';
import { dataGridPremiumBorderRadius, useDataGridNonSkeletonRowIds } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ square: boolean; squareRight: boolean }>()(
  (theme, { square, squareRight }) => ({
    footer: {
      alignItems: 'center',
      backgroundColor: theme.palette.common.white,
      borderBottom: `1px solid ${theme.appColors.rule}`,
      borderBottomLeftRadius: square ? 0 : dataGridPremiumBorderRadius,
      borderBottomRightRadius: square || squareRight ? 0 : dataGridPremiumBorderRadius,
      borderLeft: `1px solid ${theme.appColors.rule}`,
      borderRight: `1px solid ${theme.appColors.rule}`,
      borderTop: `1px solid ${theme.appColors.rule}`,
      boxSizing: 'border-box',
      display: 'flex',
      minHeight: 32,
      padding: theme.spacing(0.5, 2),
      width: '100%',
    },
  })
);

export interface ListCountFooterProps {
  noun?: string;
  square?: boolean;
  /** Squares only the bottom-right corner — for grids with a side panel beside the footer. */
  squareRight?: boolean;
  totalCount?: number;
}

export function ListCountFooter({
  noun = 'items',
  square = false,
  squareRight = false,
  totalCount = 0,
}: ListCountFooterProps): JSX.Element | null {
  const { classes } = useStyles({ square, squareRight });
  const nonSkeletonRowIds = useDataGridNonSkeletonRowIds();
  const loadedCount = Math.min(nonSkeletonRowIds.length, totalCount);

  return (
    <div className={classes.footer}>
      <Typography noWrap color="textSecondary" variant="body2">
        {formatNumber(loadedCount)}/{formatNumber(totalCount)} {noun} loaded
      </Typography>
    </div>
  );
}

function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(num);
}
